export class AuditReportEntries {
    public DbLogId: number;
    public UserId: number;
    public TableName: string;
    public Identifier: string;
    public CreatedDateUtc: string;
    public FieldName: string;
    public OldValue: string;
    public NewValue: string;
    public UpdateOrder: number;
    public UpdatedBy: string;
    public Action: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/audit-report/audit-report-entries.ts